import { db } from "../firebase-config";
import { collection, doc, setDoc } from "firebase/firestore";

const musicTriviaQuestions = [
  {
    id: 1,
    question: "What 1980s pop singer won a 2013 Tony for Best Original Score for the musical 'Kinky Boots'?",
    options: ["Madonna", "Cyndi Lauper", "Whitney Houston", "Pat Benatar"],
    correctAnswer: 1,
    category: "80s Music",
    difficulty: "medium"
  },
  {
    id: 2,
    question: "What Bernstein musical, set in 1950s New York, was based on Shakespeare's Romeo and Juliet?",
    options: ["My Fair Lady", "Porgy and Bess", "The Sound of Music", "West Side Story"],
    correctAnswer: 3,
    category: "Musicals",
    difficulty: "easy"
  },
  {
    id: 3,
    question: "Which is not a vocal part in an all-male barbershop quartet?",
    options: ["Tenor", "Alto", "Baritone", "Bass"],
    correctAnswer: 1,
    category: "Music Theory",
    difficulty: "medium"
  },
  {
    id: 4,
    question: "Which singer's real name is Stefani Joanne Angelina Germanotta?",
    options: ["Katy Perry", "Lady Gaga", "Lana Del Rey", "Ariana Grande"],
    correctAnswer: 1,
    category: "Pop Music",
    difficulty: "easy"
  },
  {
    id: 5,
    question: "What was Elvis Presley's first No. 1 hit in the United States?",
    options: ["Hound Dog", "Heartbreak Hotel", "Jailhouse Rock", "Blue Suede Shoes"],
    correctAnswer: 1,
    category: "Rock & Roll",
    difficulty: "medium"
  },
  {
    id: 6,
    question: "Which classical composer was deaf?",
    options: ["Mozart", "Bach", "Beethoven", "Chopin"],
    correctAnswer: 2,
    category: "Classical Music",
    difficulty: "easy"
  },
  {
    id: 7,
    question: "What instrument did Louis Armstrong famously play?",
    options: ["Saxophone", "Trumpet", "Piano", "Drums"],
    correctAnswer: 1,
    category: "Jazz",
    difficulty: "easy"
  },
  {
    id: 8,
    question: "Which band released the album 'Dark Side of the Moon'?",
    options: ["Led Zeppelin", "The Beatles", "Pink Floyd", "The Rolling Stones"],
    correctAnswer: 2,
    category: "Rock Music",
    difficulty: "easy"
  },
  {
    id: 9,
    question: "What does 'K-pop' stand for?",
    options: ["Korean Pop", "Kingdom Pop", "Kawaii Pop", "Kool Pop"],
    correctAnswer: 0,
    category: "World Music",
    difficulty: "easy"
  },
  {
    id: 10,
    question: "Which artist has won the most Grammy Awards?",
    options: ["Jay-Z", "Beyoncé", "Kanye West", "Taylor Swift"],
    correctAnswer: 1,
    category: "Awards",
    difficulty: "medium"
  },
  {
    id: 11,
    question: "What year did MTV launch?",
    options: ["1979", "1981", "1983", "1985"],
    correctAnswer: 1,
    category: "Music History",
    difficulty: "hard"
  },
  {
    id: 12,
    question: "Which instrument has 88 keys?",
    options: ["Organ", "Harpsichord", "Piano", "Accordion"],
    correctAnswer: 2,
    category: "Instruments",
    difficulty: "easy"
  },
  {
    id: 13,
    question: "Who sang the theme song for the James Bond movie 'Skyfall'?",
    options: ["Sam Smith", "Adele", "Billie Eilish", "Shirley Bassey"],
    correctAnswer: 1,
    category: "Movie Soundtracks",
    difficulty: "easy"
  },
  {
    id: 14,
    question: "What is the best-selling album of all time?",
    options: ["Back in Black - AC/DC", "The Dark Side of the Moon - Pink Floyd", "Thriller - Michael Jackson", "The Beatles - The Beatles"],
    correctAnswer: 2,
    category: "Music History",
    difficulty: "medium"
  },
  {
    id: 15,
    question: "Which city is often referred to as the birthplace of jazz?",
    options: ["Chicago", "New York", "Memphis", "New Orleans"],
    correctAnswer: 3,
    category: "Jazz",
    difficulty: "medium"
  },
  {
    id: 16,
    question: "What does the musical term 'forte' mean?",
    options: ["Soft", "Loud", "Fast", "Slow"],
    correctAnswer: 1,
    category: "Music Theory",
    difficulty: "easy"
  },
  {
    id: 17,
    question: "Which member of The Beatles was murdered in New York City in 1980?",
    options: ["Paul McCartney", "John Lennon", "George Harrison", "Ringo Starr"],
    correctAnswer: 1,
    category: "Rock History",
    difficulty: "easy"
  },
  {
    id: 18,
    question: "What is Taylor Swift's middle name?",
    options: ["Alison", "Marie", "Elizabeth", "Anne"],
    correctAnswer: 0,
    category: "Pop Music",
    difficulty: "hard"
  },
  {
    id: 19,
    question: "Which rapper's real name is Marshall Mathers?",
    options: ["50 Cent", "Eminem", "Dr. Dre", "Snoop Dogg"],
    correctAnswer: 1,
    category: "Hip Hop",
    difficulty: "easy"
  },
  {
    id: 20,
    question: "What was the first music video played on MTV?",
    options: ["Video Killed the Radio Star", "Thriller", "Billie Jean", "Take On Me"],
    correctAnswer: 0,
    category: "Music History",
    difficulty: "medium"
  },
  {
    id: 21,
    question: "Which instrument is Yo-Yo Ma famous for playing?",
    options: ["Violin", "Cello", "Viola", "Double Bass"],
    correctAnswer: 1,
    category: "Classical Music",
    difficulty: "medium"
  },
  {
    id: 22,
    question: "What band was Freddie Mercury the lead singer of?",
    options: ["The Rolling Stones", "Led Zeppelin", "Queen", "The Who"],
    correctAnswer: 2,
    category: "Rock Music",
    difficulty: "easy"
  },
  {
    id: 23,
    question: "Which country did AC/DC originate from?",
    options: ["United States", "United Kingdom", "Australia", "Canada"],
    correctAnswer: 2,
    category: "Rock Music",
    difficulty: "medium"
  },
  {
    id: 24,
    question: "What is the stage name of Robert Zimmerman?",
    options: ["Bob Marley", "Bob Dylan", "Bob Seger", "Bob Geldof"],
    correctAnswer: 1,
    category: "Folk Music",
    difficulty: "medium"
  },
  {
    id: 25,
    question: "Which instrument family does the flute belong to?",
    options: ["Brass", "Woodwind", "String", "Percussion"],
    correctAnswer: 1,
    category: "Music Theory",
    difficulty: "easy"
  }
];

export const initializeQuizData = async () => {
  try {
    const quizRef = collection(db, "quiz");
    const docRef = doc(quizRef, "musicTriviaQuestions");
    
    await setDoc(docRef, {
      title: "Music Trivia Questions",
      description: "A collection of music trivia questions covering various genres and eras",
      questions: musicTriviaQuestions,
      totalQuestions: musicTriviaQuestions.length,
      categories: ["80s Music", "Musicals", "Music Theory", "Pop Music", "Rock & Roll", 
                   "Classical Music", "Jazz", "Rock Music", "World Music", "Awards", 
                   "Music History", "Instruments", "Movie Soundtracks", "Hip Hop", "Folk Music"],
      createdAt: new Date().toISOString(),
      lastUpdated: new Date().toISOString()
    });
    
    console.log("Quiz data initialized successfully!");
    return { success: true, message: "Quiz collection created with music trivia questions" };
  } catch (error) {
    console.error("Error initializing quiz data:", error);
    return { success: false, error: error.message };
  }
};

export const getMusicTriviaQuestions = () => musicTriviaQuestions;